import styled from 'styled-components'
import { Card } from 'antd'

import { colors } from 'src/common/constants'

export const StyledCard = styled(Card)`
  border-color: ${colors.grey2};
`

export const ContentWrapper = styled.div`
  display: grid;
  gap: 8px;
`
export const ContentField = styled.div`
  display: grid;
  gap: 8px;
  grid-template-columns: auto 1fr;
  align-items: center;
`
export const ContentFieldIcon = styled.div`
  font-size: 20px;
  color: ${colors.main};
`
export const ContentFieldLabel = styled.div``
